import { jsxs as u, jsx as o } from "react/jsx-runtime";
import { Barcode as m } from "../Barcode/Barcode.js";
import { classes as x } from "../../utils/styles.js";
import { useState as j, useRef as y, useLayoutEffect as b } from "react";
import '../../assets/CustomerCard.css';const g = "_card_uvxjl_1", H = "_value_uvxjl_23", w = "_open_uvxjl_26", C = "_bold_uvxjl_38", a = {
  card: g,
  "barcode-wrapper": "_barcode-wrapper_uvxjl_19",
  value: H,
  open: w,
  bold: C,
  "card-header": "_card-header_uvxjl_42"
}, R = ({
  marketingName: t,
  companyName: c,
  customerNumber: _,
  withoutText: i,
  isOpen: e,
  onSelect: d,
  delay: h,
  ...f
}) => {
  const [s, p] = j(0), l = y(null), v = (r) => {
    (r.key === "Enter" || r.key === " ") && d();
  };
  return b(() => {
    var n;
    const r = ((n = l.current) == null ? void 0 : n.offsetHeight) ?? 0;
    p(r);
  }, []), /* @__PURE__ */ u(
    "div",
    {
      className: x(a.card, e && a.open),
      style: {
        ...h && e && { transitionDelay: "0.2s" },
        ...!e && { height: s }
      },
      ...f,
      tabIndex: 0,
      onClick: d,
      onKeyDown: v,
      children: [
        /* @__PURE__ */ u("div", { className: a["card-header"], ref: l, children: [
          /* @__PURE__ */ o("span", { className: a.bold, children: t }),
          t !== c && /* @__PURE__ */ o("span", { children: c })
        ] }),
        /* @__PURE__ */ o(
          m,
          {
            style: {
              ...e && s > 92 && { marginTop: 16 - (s - 92) }
            },
            value: _,
            withoutText: i
          }
        )
      ]
    }
  );
};
export {
  R as CustomerCard
};
